/*
  @kritical-tag-v1034
  path: assets/kritical-product-zoom.js
  4-way-class: KRITICAL-IP
  huzaifa-vs-pax8-class: NETLINK-EVOLVED-NO-PAX8
  last-modified-wave: .1034
  see-also: CLAUDE.md (search '.1034') + reference/PROGRAM-LEDGER.md
  migration: jquery.zoom.min.js ($('.zoom').zoom(2)) + jquery.ez-plus.js ($('.zoom_out').ezPlus())
             -> native CSS transform:scale + mousemove origin tracking (IntersectionObserver-safe,
             prefers-reduced-motion aware). jQuery 4.0 blocker eliminated.
  DOM hooks preserved: .zoom (container), .zoom_out (img), data-zoom-mode on section.
  Modes: zoom (inner 2x scale), outer (inner 2x scale, side-by-side UX approximated),
         cloud (inner 2x scale with round-lens cursor style).
*/
(function () {
  'use strict';

  var ZOOM_SELECTOR = '.zoom';
  var SCALE_FACTOR = 2;

  function initZoomOnContainer(container) {
    if (!container || container.dataset.kriticalZoomInit === 'true') { return; }
    container.dataset.kriticalZoomInit = 'true';

    var img = container.querySelector('img');
    if (!img) { return; }

    img.style.willChange = 'transform';
    img.style.transition = 'transform 0.08s ease-out';
    img.style.transformOrigin = '50% 50%';

    function onMouseMove(e) {
      var rect = container.getBoundingClientRect();
      var xPct = ((e.clientX - rect.left) / rect.width) * 100;
      var yPct = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = xPct + '% ' + yPct + '%';
      img.style.transform = 'scale(' + SCALE_FACTOR + ')';
    }

    function onMouseLeave() {
      img.style.transform = '';
      img.style.transformOrigin = '50% 50%';
    }

    function onTouchStart() {
      /* on touch devices skip zoom to avoid scroll interference */
    }

    container.addEventListener('mousemove', onMouseMove);
    container.addEventListener('mouseleave', onMouseLeave);
    container.addEventListener('touchstart', onTouchStart, { passive: true });
  }

  function bootstrap(mode) {
    if (!mode || mode === 'default') { return; }

    /* Respect prefers-reduced-motion */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    document.querySelectorAll(ZOOM_SELECTOR).forEach(function (el) {
      initZoomOnContainer(el);
    });
  }

  function autoDiscover() {
    var section = document.querySelector('[data-zoom-mode]');
    if (section) {
      bootstrap(section.dataset.zoomMode);
    }
  }

  /* Public API — called by Liquid inline script or auto-discovered via data attribute */
  window.KriticalProductZoom = {
    init: bootstrap,
    discover: autoDiscover
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoDiscover);
  } else {
    autoDiscover();
  }
})();
